import { Routes, Route } from "react-router-dom";
import "./App.css";
import React from "react";
import HrDashboard from "./pages/HrDashboard";

import AppraisalManagement from "./pages/AppraisalManagement";
import Reminder from "./pages/Reminder";
import ViewAppraisal from "./pages/ViewAppraisal";
import Reports from "./pages/Reports";
import LoginPage from "./components/LoginPage";
import SubmitAppraisal from "./pages/SubmitAppraisal";
import EditAppraisal from "./pages/EditAppraisal";
import SupDashboard from "./pages/SupDashboard";
import MyAppraisal from "./pages/MyAppraisal";
import AppraisalAssessment from "./pages/AppraisalAssessment";
import EditAppraisalAssessment from "./pages/EditAppraisalAssessment";
import ViewStaffAppraisal from "./pages/ViewStaffAppraisal";
import History from "./pages/History";
import SignaturePad from "./components/SignaturePad";
import { ThemeProvider } from "./components/ThemeContext";

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/hr-dashboard" element={<HrDashboard />} />
        <Route path="/appraisal-management" element={<AppraisalManagement />} />
        <Route path="/remind-appraisal" element={<Reminder />} />
        <Route path="/view-appraisal" element={<ViewAppraisal />} />
        <Route path="/reporting" element={<Reports />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/submit-appraisal/:role_id" element={<SubmitAppraisal />} />
        <Route path="/edit-appraisal/:role_id" element={<EditAppraisal />} />
        <Route path="/view-staffappraisal/:role_id/:staff_id" element={<ViewStaffAppraisal />} />
        <Route path="/appraisal-assessment" element={<AppraisalAssessment />} />
        <Route path="/edit-assessment" element={<EditAppraisalAssessment />} />
        <Route path="/sup-dashboard" element={<SupDashboard />} />
        <Route path="/my-appraisal" element={<MyAppraisal />} />
        <Route path="/history" element={<History />} />
        <Route path="/signature" element={<SignaturePad/>} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
